<template>
<!-- ShopTable.vue -->
  <div class="shop_table" :class="{ shop_table_limit_2: product_count <= 2 }">
    <pre>activeProductIds: {{ activeProductIds }}</pre>
    <shop-row
      v-for="(p, i) in products"
      :row="p"
      :isPackage="isPackage"
      :key="
        'shop-table-products-' + isPackage
          ? p.PackageKey
          : p.EntityHierarchyKey + '-' + i
      "
    />
    <!-- <pre>products: {{products}}</pre> -->
  </div>
</template>

<script>
import ShopRow from "../components/ShopRow.vue";
import { mapState } from "vuex";

export default {
  props: ["products", "isPackage"],
  components: {
    ShopRow
  },
  computed: {
    ...mapState(["activeProductIds"]),
    product_count() {
      return this.products ? this.products.length : 0;
    }
  }
};
</script>

<style></style>
